import { render, staticRenderFns } from "./view-quotation.vue?vue&type=template&id=e8554534&scoped=true"
import script from "./view-quotation.vue?vue&type=script&lang=js"
export * from "./view-quotation.vue?vue&type=script&lang=js"
import style0 from "./view-quotation.vue?vue&type=style&index=0&id=e8554534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8554534",
  null
  
)

export default component.exports